// extracted by mini-css-extract-plugin
module.exports = {"container":"Camera_container__6ODF0","animation":"Camera_animation__1d6HP","zoomWindow":"Camera_zoomWindow__2EJEt"};